module.exports = __webpack_public_path__ + "static/media/up-caret.8e0d324b.svg";